var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeditation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    width: 297,
    height: 297,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fillOpacity: 1,
    fill: "#6867ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.5,102.433c26.485,0,48.861-23.244,48.861-50.758c0-26.335-21.463-46.965-48.861-46.965S99.639,25.34,99.639,51.675   C99.639,79.189,122.015,102.433,148.5,102.433z M148.5,23.872c16.932,0,29.7,11.953,29.7,27.803   c0,16.832-13.879,31.597-29.7,31.597s-29.7-14.765-29.7-31.597C118.8,35.825,131.568,23.872,148.5,23.872z",
    id: "svg_2",
    fill: "#6867ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.471,292.29c21.245,0,38.529-17.285,38.529-38.53c0-8.813-3.577-16.887-8.459-24.073   c-8.187-12.05-45.416-78.962-64.361-99.691c-16.204-17.729-54.01-25.703-75.68-25.703s-59.476,7.974-75.68,25.703   c-18.945,20.729-56.174,87.641-64.361,99.691C3.577,236.872,0,244.946,0,253.759c0,21.246,17.285,38.53,38.529,38.53H258.471z    M210.035,142.921c11.928,13.051,33.381,47.863,47.895,72.316c-1.41,0.02-2.824,0.114-4.238,0.29l-25.307,3.163l-26.447-47.963   c-1.794-3.253-5.564-4.878-9.161-3.954c-3.598,0.926-6.113,4.171-6.113,7.886v49.246l-18.475,2.309l-57.85-4.954v-4.369   l84.865-83.546C201.434,136.064,206.706,139.279,210.035,142.921z M210.984,220.866l-8.035,1.004v-15.576L210.984,220.866z    M94.05,219.866l-7.146-0.612l7.146-12.96V219.866z M86.965,142.921c11.024-12.062,43.27-19.468,61.535-19.468   c8.626,0,20.37,1.654,31.525,4.668l-69.687,68.604V174.66c0-3.715-2.515-6.96-6.113-7.886c-3.599-0.923-7.368,0.702-9.161,3.954   l-25.919,47.005l-26.035-2.23c-1.347-0.161-2.695-0.25-4.038-0.269C53.583,190.784,75.033,155.976,86.965,142.921z M23.908,241.355   c3.109-3.651,11.279-7.072,15.967-6.872c31.868,1.359,127.124,10.862,127.124,10.862l6.081,27.783H38.529   c-10.68,0-19.368-8.689-19.368-19.369C19.161,250.027,21.58,244.09,23.908,241.355z M273.103,241.373   c2.316,2.726,4.736,8.669,4.736,12.386c0,10.68-8.688,19.369-19.368,19.369h-65.777l-6.532-29.849l69.906-8.738   C261.655,233.844,269.454,237.079,273.103,241.373z",
    id: "svg_3",
    fill: "#6867ac"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditation);
export default __webpack_public_path__ + "static/media/meditation.bb117ec3a0764c36a9789f41cbda633e.svg";
export { ForwardRef as ReactComponent };